
import React from 'react';
import Hero from '@/components/Hero';
import Solutions from '@/components/Solutions';
import FreeConsultation from '@/components/FreeConsultation';
import CompanyOpening from '@/components/CompanyOpening';
import Plans from '@/components/Plans'; // Added
import CompanyLogos from '@/components/CompanyLogos'; // Added
import About from '@/components/About';
import TaxRecovery from '@/components/TaxRecovery';
import Testimonials from '@/components/Testimonials';
import Scheduling from '@/components/Scheduling';
import Location from '@/components/Location'; // Added
import Footer from '@/components/Footer'; // Added

const Home = () => {
  return (
    <main>
      <Hero />
      <FreeConsultation />
      <About />
      <Solutions />
      <Plans /> {/* Rendered Plans component */}
      <CompanyLogos /> {/* Rendered CompanyLogos component */}
      <TaxRecovery />
      <Testimonials />
      <CompanyOpening />
      <Scheduling />
      <Location /> {/* Rendered Location component */}
      <Footer /> {/* Rendered Footer component */}
    </main>
  );
};

export default Home;
